
import { NgModule } from '@angular/core';
import {
    MatDialogModule,
    MatCheckboxModule,
    MatDividerModule,
    MatFormFieldModule,
    MatButtonModule,
    MatGridListModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MAT_DATE_LOCALE,
    MatRadioModule,
    MatInputModule,
    MatIconModule,
    MatExpansionModule,
    MatTooltipModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { AddOccurenceModalComponent } from './add-occurence-modal.component';
import { CommonModule } from '@angular/common';
import { OccurenceTypesComponent } from './occurence-types/occurence-types.component';
import { OccurenceDataComponent } from './occurence-data/occurence-data.component';
import { OccurenceAttachmentsComponent } from './occurence-attachments/occurence-attachments.component';
import { OccurenceCommentsComponent } from './occurence-comments/occurence-comments.component';
import { OccurenceDatesComponent } from './occurence-dates/occurence-dates.component';
import { OccurenceDescriptionComponent } from './occurence-description/occurence-description.component';

import { SharedModule } from '../../shared/shared.module';
import { OccurenceListCommentsComponent } from './occurence-list-comments/occurence-list-comments.component';
import { OccurenceAddCommentsComponent } from './occurence-add-comments/occurence-add-comments.component';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OccurrenceReadManagerComponent } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurrence-read-manager/occurrence-read-manager.component';
import { OccurrenceCommentReadByComponent } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurrence-comment-read-by/occurrence-comment-read-by.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Overlay } from '@angular/cdk/overlay';
import { CloseScrollStrategy } from '@angular/cdk/overlay';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(
        http,
        './assets/i18n/', // or whatever path you're using
        '.json'
    );
}

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
	return () => overlay.scrollStrategies.close();
}

@NgModule({
    declarations: [
        AddOccurenceModalComponent,
        OccurenceTypesComponent,
        OccurenceDataComponent,
        OccurenceAttachmentsComponent,
        OccurenceCommentsComponent,
        OccurenceDatesComponent,
        OccurenceDescriptionComponent,
        OccurenceListCommentsComponent,
        OccurenceAddCommentsComponent,
        OccurrenceReadManagerComponent,
        OccurrenceCommentReadByComponent
    ],
    exports: [
        AddOccurenceModalComponent,
        MatExpansionModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        BrowserAnimationsModule
    ],
    imports: [
        MatDialogModule,
        CommonModule,
        MatSelectModule,
        MatCheckboxModule,
        MatDividerModule,
        MatFormFieldModule,
        MatButtonModule,
        MatGridListModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        SharedModule,
        MatIconModule,
        MatExpansionModule,
        BrowserAnimationsModule,
        ScrollingModule,
        TranslateModule.forRoot({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          }),
        MatTooltipModule,
        MatNativeDateModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatProgressSpinnerModule,
        ScrollDispatchModule 
    ],
    entryComponents: [
        AddOccurenceModalComponent
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY, useFactory: scrollFactory, deps: [Overlay] }
        
    ]
})
export class AddOccurenceModalModule { }
